module.exports = __webpack_public_path__ + "media/images/icons/001__arrow_left-1a04bc1ea7b0f2838cb6a73d721852da.svg";